import { mockResellerStats } from "@/mocks/reseller";

const StatsCards = () => {
  const stats = [
    {
      icon: "ri-shopping-bag-3-line",
      label: "Total Sales",
      value: mockResellerStats.totalSales.toLocaleString(),
      sub: `${mockResellerStats.thisMonthSales} this month`,
      color: "text-[#C41E3A]",
      bg: "bg-[#C41E3A]/10",
    },
    {
      icon: "ri-money-dollar-circle-line",
      label: "Total Commission",
      value: `$${mockResellerStats.totalCommission.toLocaleString()}`,
      sub: `$${mockResellerStats.thisMonthCommission.toLocaleString()} this month`,
      color: "text-[#D4AF37]",
      bg: "bg-[#D4AF37]/10",
    },
    {
      icon: "ri-paypal-line",
      label: "Pending Payout",
      value: `$${mockResellerStats.pendingPayout.toLocaleString()}`,
      sub: "Pays out on May 1",
      color: "text-green-600",
      bg: "bg-green-50",
    },
    {
      icon: "ri-cursor-line",
      label: "Total Link Clicks",
      value: mockResellerStats.totalClicks.toLocaleString(),
      sub: `${mockResellerStats.conversionRate}% conversion rate`,
      color: "text-amber-600",
      bg: "bg-amber-50",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white rounded-xl p-5 border border-gray-100">
          <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${stat.bg} mb-3`}>
            <i className={`${stat.icon} ${stat.color} text-xl`}></i>
          </div>
          <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
          <div className="text-xs text-gray-500 mt-0.5">{stat.label}</div>
          <div className={`text-xs font-medium mt-1 ${stat.color}`}>{stat.sub}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;
